import type { FeatureFlag } from '@forgd/shared/feature-flags'

export function useFeatureEnabled(featureFlag: FeatureFlag) {
  const auth = useAuth()
  return computed(() => auth.featureFlags.includes(featureFlag))
}

export function useFeatureFlagsReady() {
  const auth = useAuth()
  return computed(() => auth.flagsReady)
}
